<template>
<!-- FINAL ICARE -->
  <form @submit.prevent>
     <CModal
        :title.sync="title" 
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
            <CInput v-model="form.marriage_certificate_no"  label="Marriage Certificate No"   />
            <CInput v-model="form.marriage_date"  label="Marriage Date" type="date"  />
            <CInput v-model="form.marriage_church"  label="Marriage Church"   />
          </CCol> 
          </CRow>
       
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.uuid)"  variant="outline" color="info">Update</CButton>
     
        </template>
    </CModal>
  </form>
</template>
<script>
import EventBus from '@/eventBus';

import member from '@/services/member';
import satelite from '@/services/satelitechurch'
import icare from '@/services/icare'

import moment from 'moment'

export default {
name: 'marriagemodal',
  data () {
    return {
    show: false,
    title: 'Default Title',
    mode: '',
    form:{
      uuid:'',
      marriage_certificate_no:'',
      marriage_date:'',
      marriage_church:'',
    },
    }
  },
   mounted (){
    //  this.load()

    //   EventBus.$on('PAGE_UPDATE', (data) => {
    //   if(data){
    //       this.load();
    //   }
    // });
   },
  
  created () {
    var self = this; 
      EventBus.$on('OPEN_MODAL_MARRIAGE', (params) => {
      if(params.data){
      member.getMarriage(params.data)
      .then(res => {
      self.show = true;
      self.title = params.title;
      self.mode = params.mode;
      self.form.uuid = params.data;
      self.form.marriage_certificate_no = res.data.marriage_certificate_no;
      self.form.marriage_date = res.data.marriage_date;
      self.form.marriage_church = res.data.marriage_church;
       }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.uuid = "";
        self.form.marriage_certificate_no = "";
        self.form.marriage_date = "";
        self.form.marriage_church = "";
      }
 
    });
    
  },
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    update(id){
      this.show = false;
      this.form.marriage_date = moment(this.form.marriage_date).format ('DD/MM/YYYY')
      member.updateMarriage(id, this.form)
      .then(res => {
        EventBus.$emit('PAGE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    
   
  }
}
</script>

<style>

</style>